import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})


export class NotificationPush {

  
  requestPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
      });
    }

  }


  showNotification(title: string, options?: NotificationOptions) {
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, options);
    }
  }



}
